
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import {
  getAlpha,
  delayedBoundsCall,
  useMouseEvents
} from "@/components/Reusable/CustomInputs/3rdPartyWrappers/Gradient/helpers";

type Positions = { startX: number; positionX: number };

@Component
export default class Alpha extends Vue {
  @Prop()
  red!: number;

  @Prop()
  green!: number;

  @Prop()
  blue!: number;

  @Prop()
  alpha!: number;

  @Prop()
  updateColor!: Function;

  width = 0;
  mouseEvents: (event: MouseEvent) => void = () => {};

  mounted() {
    delayedBoundsCall(this.calculateBounds);

    this.mouseEvents = useMouseEvents(
      this.mouseDownHandler,
      this.mouseMoveHandler,
      this.mouseUpHandler
    );
  }

  get offsetLeft() {
    return ((this.alpha * this.width) | 0) - 6;
  }

  get pointerStyle() {
    return { left: `${this.offsetLeft}px` };
  }

  get style() {
    return {
      background: `linear-gradient(to right, rgba(0, 0, 0, 0), rgb(${this.red}, ${this.green}, ${this.blue}))`
    };
  }

  calculateBounds() {
    const alpha = this.$refs.alphaMaskRef as HTMLElement;

    if (alpha) {
      this.width = alpha.clientWidth;
    }
  }

  mouseDownHandler(event: MouseEvent) {
    const startX = event.pageX;
    const target = event.currentTarget as HTMLElement;
    const elementX = target.getBoundingClientRect().x;
    const positionX = startX - elementX;

    this.updateColor(
      { alpha: getAlpha(positionX, this.width) },
      "onStartChange"
    );

    return {
      startX,
      positionX
    };
  }

  changeObjectPositions(event: MouseEvent, { startX, positionX }: Positions) {
    const pageX = event.pageX;

    const moveX = pageX - startX;
    positionX += moveX;

    const alpha = getAlpha(positionX, this.width);

    return {
      positions: {
        positionX,
        startX: pageX
      },
      alpha
    };
  }

  mouseMoveHandler(event: MouseEvent, { startX, positionX }: Positions) {
    event.preventDefault();
    const { positions, alpha } = this.changeObjectPositions(event, {
      startX,
      positionX
    });

    this.updateColor({ alpha }, "onChange");

    return positions;
  }

  mouseUpHandler(event: MouseEvent, { startX, positionX }: Positions) {
    event.preventDefault();
    const { positions, alpha } = this.changeObjectPositions(event, {
      startX,
      positionX
    });

    this.updateColor({ alpha }, "onEndChange");

    return positions;
  }
}
